// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"d31ca158","400":"0635a7c9","479":"9e1344f5","775":"d31ca158","795":"ec0b7585"}[chunkId] + ".chunk.css";
};